// React Lazily
import { lazily } from 'react-lazily'

// Interface
import { IRoute } from 'routes/route.interface'

// Constant
import { MASTER_URL, MASTER_MODULE } from 'constant/url.constant'
import { LAYOUT } from 'constant/layout.constant'

// UI
const { CompanyIndex } = lazily(() => import('pages/back-office/master/company'))

const companyRoutes: IRoute[] = [
  {
    path: MASTER_URL.COMPANY,
    component: CompanyIndex,
    layout: LAYOUT.BACK_OFFICE,
    exact: true,
    meta: {
      module: MASTER_MODULE,
      requireAuth: true,
      attrs: {
        label: 'masterCompany.company',
        accessCodes: [995],
      },
    },
  },
]

export { companyRoutes }
